export default {
  loading(state, value) {
    state.isLoading = value;
  },
  snackBar(state, value) {
    state.isSnackBar = value;
  },
  setToken(state, token) {
    state.token = token;
  },
  setESignToken(state, esignToken) {
    state.esignToken = esignToken;
  },
  setOperation(state, operation) {
    state.operation = operation;
  },
  setOperationUuid(state, uuid) {
    state.operationUuid = uuid;
  },
  setDomainUuid(state, domainUuid) {
    state.domainUuid = domainUuid;
  },
  setDocumentUuid(state, documentUuid) {
    state.documentUuid = documentUuid;
  },
  setVideoUuid(state, videoUuid) {
    state.videoUuid = videoUuid;
  },
  setCellphone(state, cellphone) {
    state.cellphone = cellphone;
  },
  setSignBoxName(state, name) {
    state.signBoxName = name;
  },
  setAttachDocumentUuid(state, name) {
    state.attachDocumentUuid = name;
  },
  setUserEmail(state, name) {
    state.userEmail = name;
  },
  setUserUid(state, name) {
    state.userUid = name;
  },
  setUserToken(state, name) {
    state.userToken = name;
  },
  setUserData(state, name) {
    state.userData = name;
  },
  setCredits(state, credits) {
    state.credits = credits;
  },
  setUserdones(state, usedones) {
    state.usedones = usedones;
  },
  setUserLoggedIn(state, name) {
    state.userLoggedIn = name;
  }
};
